var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon/Status/Outline/Error/Error",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.5,
    height: 33.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "m14.359 16.317-.132-.117L8.3 10.279 2.383 16.2a1.4 1.4 0 0 1-2.09-1.842l.116-.132L6.331 8.3.408 2.383A1.4 1.4 0 0 1 2.251.293l.132.116L8.3 6.331 14.227.408a1.4 1.4 0 0 1 2.09 1.843l-.117.132L10.279 8.3l5.921 5.927a1.4 1.4 0 0 1-1.842 2.09z",
    transform: "translate(8.445 8.445)",
    style: {
      fill: "#091119"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineError);
export default __webpack_public_path__ + "static/media/OutlineError.21beac8e4bd2bb98bf01b2373be5731f.svg";
export { ForwardRef as ReactComponent };